import type { AnnotatedJsonSchema } from '@web-config-app/core';

export const isArrayOrObjectSchema = ({ type }: AnnotatedJsonSchema) =>
  ['object', 'array'].includes(String(type));
